<template>
  <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation"
       :class="{ slideInDown: show, slideOutDown: !show }">
    <div id="specialShadow" class="bd-special-shadow" style="opacity: 1; transform: scaleY(1);"></div>
    <div class="navbar-brand">
      <a class="navbar-item" href="#">
        <img src="../../assets/volleyball.svg" style="height:1.4rem">
        <span class="vue">Volley</span><span class="admin">Admin3</span>
      </a>
    </div>
    <div class="navbar-end" >
      <a class="navbar-item a-login" @click="showUserContent = true" >
        <span class="login" style="cursor:pointer;"><i class="mdi mdi-account"></i> {{this.Username}}</span>
      </a>
      <transition name="fade">
        <div class="usercontent panel" v-if="showUserContent">
          <p class="panel-heading">
            <span class="title is-5 has-text-primary">Account: {{this.Username}}</span>
          </p>
          <div >
            <div class="panel-block">
              <div v-if="ChangingPassword">
                <div class="columns">
                  <div class="column">
                    <label class="label">New Password</label>
                    <input class="input" type="password" v-model="Password">
                    <span v-show="Password == ''" class="help is-danger" style="color:red; background-color:white;font-style:italic;"> Enter password</span>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <label class="label">Confirm Password</label>
                    <input class="input" type="password" v-model="Password2">
                    <span v-show="Password !== Password2" class="help is-danger" style="color:red; background-color:white;font-style:italic;">Passwords not equal</span>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="field">
                      <button class="button is-primary" :disabled="!PassWordsValid" v-on:click="ResetPassword">
                        Reset Password
                      </button>
                      <button class="button is-warning" v-on:click="CloseChangingPassword">
                        Cancel
                      </button>
                    </p>
                  </div>
                </div>
              </div>
              <div class="columns" v-if="!ChangingPassword">
                <div class="column">
                  <p class="field">
                    <button class="button is-primary" v-on:click="ChangingPassword = true">
                      Change Password
                    </button>
                    <button class="button is-warning" v-on:click="CloseUserContent">
                      Close
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <a class="navbar-item" @click="Logout" target="_blank" title="Logout">
        <i class="mdi mdi-logout mdi-18px mdi-dark"></i>
      </a>
      <button class="button navbar-burger is-flex-mobile" @click="toggleSidebar(!sidebar.opened)">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </nav>
</template>

<script>

  import {mapGetters, mapActions} from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  import {NotifierBus} from '../../store/eventbusses.js'

  export default {
    components: {
    },
    data: function () {
      return {
        showNotifications: false,
        showServers: false,
        showUserContent: false,
        ChangingPassword: false,
        Password: '',
        Password2: ''
      }
    },
    props: {
      show: Boolean
    },
    computed: {
      ...mapGetters(['pkg', 'sidebar']),
      ...mapGetters('security', ['HasPermission', 'Username']),
      PassWordsValid () {
        return this.Password === this.Password2 && this.Password !== ''
      }
    },
    methods: {
      ...mapActions(['toggleSidebar']),
      ...mapActions('security', ['Logout']),
      showTimestamp (infoMessage) {
        return moment(infoMessage.timestamp).format('DD/MM/Y HH:mm:ss')
      },
      CloseUserContent () {
        this.Password = ''
        this.Password2 = ''
        this.showUserContent = false
      },
      CloseChangingPassword () {
        this.Password = ''
        this.Password2 = ''
        this.ChangingPassword = false
      },
      ResetPassword () {
        let obj = {
          'uacuser_password': this.Password,
          'uacuser_id': this.UserToken.userid
        }
        axios.post(this.$store.state.vaconfig.ServerURL + 'uacusers/changepassword/', {data: obj})
          .then((response) => {
            if (response.data.success) {
              NotifierBus.$emit('Notify', {
                type: 'info',
                title: 'Password Reset',
                message: 'Password of ' + response.data.data.uacuser_username + ' changed successfully.',
                duration: 0
              })
            } else {
              NotifierBus.$emit('Notify', {
                type: 'danger',
                title: response.data.title,
                message: response.data.message,
                duration: 0
              })
            }
          }).catch((error) => {
            console.log('error during post btdevices/import' + error)
          })
        this.showUserContent = false
        this.ChangingPassword = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/colors.scss";

  .navbar-item {
    display: flex;
  }

  .navbar,
  .navbar-menu,
  .navbar-start,
  .navbar-end {
    align-items: stretch;
    display: flex;
    padding: 0;
  }

  .navbar-menu{
    flex-grow: 1;
    flex-shrink: 0;
  }
  .navbar-start{
    justify-content: flex-start;
    margin-right: auto;
  }
  .navbar-end{
    justify-content: flex-end;
    margin-left: auto;
  }


  .disabledlink {
    pointer-events: none;
    cursor: default;
    opacity: 0.6;
  }

  @media screen and (min-width: 800px) {
    .notificationcontent {
      background-color: white;
      position: absolute;
      top: 35px;
      left: -585px;
      width: 620px;
      border-radius: 10px;
      z-index: 5;
    }

    .servercontent {
      background-color: white;
      position: absolute;
      top: 35px;
      left: -585px;
      width: 620px;
      border-radius: 10px;
      z-index: 5;
    }
    .usercontent {
      background-color: white;
      position: absolute;
      top: 35px;
      right: 125px;
      width: 250px;
      border-radius: 10px;
      z-index: 5;
    }

  }
  @media screen and (max-width: 800px) {
    .notificationcontent {
      background-color: white;
      position: fixed;
      top: 40px;
      left: 5px;
      margin-right: 5px;
      width:calc(100% - 10px);
      border-radius: 10px;
    }

    .servercontent {
      background-color: white;
      position: fixed;
      top: 40px;
      left: 5px;
      margin-right: 5px;
      width:calc(100% - 10px);
      border-radius: 10px;
    }
    .usercontent {
      background-color: white;
      position: fixed;
      top: 40px;
      left: 5px;
      margin-right: 5px;
      width:calc(100% - 10px);
      border-radius: 10px;
    }
  }

  .notificationcontentitems {
    overflow-y: auto;
    max-height: 300px;
    border-radius: 0px 0px 7px 7px;
    border: 1px solid #dbdbdb;
  }

  .notificationcontent > .panel-heading {
    border-radius: 7px 7px 0 0;
    background-color: white;
  }

  .notificationcontentitems > table > tbody > tr > td {
    padding: 0.2rem;
    margin-bottom: 0.1rem;
    border-bottom: 1px solid #bdbdbd
  }

  .servercontentitems {
    overflow-y: hidden;
  //  max-height:310px;
  }

  .servercontentitems .panel-block {
    display: block;
  }

  .servercontent > .panel-heading {
    border-radius: 7px 7px 0 0;
    background-color: white;
  }

  .servercontent > .panel-heading > .title {
    color: #fff;
  }

  .servercontent > .panel-block:last-child {
    border-radius: 0px 0px 7px 7px;
  }
  .usercontent > .panel-heading {
    border-radius: 7px 7px 0 0;
    background-color: white;
  }
  .usercontent > .panel-heading > .title {
    color: #fff;
  }

  .usercontent > .panel-block:last-child {
    border-radius: 0px 0px 7px 7px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .is-danger {
    background-color: $lynxRed;
    color: #fff;
  }

  .a-login:hover {
    background-color: white;
    cursor: default;
  }

  .login {
    font-size: 1.2rem;
    margin-left: 10px;
    color: #006573;
    cursor: default;
  }

  .vue {
    font-size: 1.2rem;
    margin-left: 10px;
    color: #006573;
  }

  .admin {
    font-size: 1.2rem;
    color: #28374B;
  }

  .error {
    color: #aa0000;
  }

  .bd-special-shadow {
    background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0.1)), to(transparent));
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), transparent);
    height: 4px;
    left: 0;
    opacity: 0;
    position: absolute;
    right: 0;
    top: 100%;
    -webkit-transform: scaleY(0);
    transform: scaleY(0);
    -webkit-transform-origin: center top;
    transform-origin: center top;
  }

  .notificationbadge {
    z-index: 999;
    margin-top: -20px;
  }

</style>



// WEBPACK FOOTER //
// Navbar.vue?5b9a89a3